import { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import Button from '@aura/components/button'
import Grid from '@aura/components/grid'
import { withStyles } from '@aura/components/styles'
import { useCookies } from 'react-cookie'
import { APP_INACTIVE, APP_MAINTENANCE, FAILED_POLICY, LOGIN_ROUTE, LOGOUT_SUCCESS, SECURITY_WARNING, PASSWORD_CHANGED } from '../../../../constants/routes'
import AppBar from '../../../../components/app-bar'
import AppBarNew from '../../../../components/app-bar-tool'
import Footer from '../../../../components/footer'
import FooterNew from '../../../../components/footer-new'
import RegistrationContainer from '../../../../components/registration-container'
import MessageContainer from '../../../../components/message-container'
import { cookieNameLoginAppCookie } from '../../../../constants/app'
import { useConfig } from '../../../../utils/config'
import { hideLoader, showLoader } from '../../../../utils/loader-actions'
import styles from './styles'


const Component = ({
    classes,
    init
}) => {
    const config = useConfig()
    const history = useHistory()
    const { t: translate } = useTranslation()
    const { updateTheme } = useAuraThemeSwitcher()
    const [ title, setTitle ] = useState('')
    const [ verbiage, setVerbiage ] = useState('')
    const [ message, setMessage ] = useState('')
    const [ addButton, setAddButton ] = useState(false)
    const [ cookies ] = useCookies([ cookieNameLoginAppCookie ])
    const redirectTo = cookies[cookieNameLoginAppCookie]
    const path = window.location.pathname
    // For magic-link route, extract ?redirect= param
    const searchParams = new URLSearchParams(window.location.search)
    const magicLinkRedirect = path === '/magic-link' ? searchParams.get('redirect') : null

    useEffect(() => {
        getMessage()
    }, [ translate ])

    useEffect(() => {
        if (path !== LOGOUT_SUCCESS && path !== PASSWORD_CHANGED) {
            updateTheme({ palette: 'light' })
        }
    }, [])

    useEffect(() => {
        setAddButton(false)
        getMessage()
        if (path === LOGOUT_SUCCESS || path === PASSWORD_CHANGED) {
            const runInit = async () => {
                await init(false, config?.oktaCurrentSession, config?.logoutOAGSession, config?.cmxClean, config?.secure2Clean, config?.protectedClean, config?.digitalMarketplace)
                hideLoader()
                setAddButton(true)
            }
            runInit()
        } else if (path === '/magic-link' && magicLinkRedirect) {
            setAddButton(true)
        }
    }, [])

    const handleOnclick = useCallback(() => {
        if (path === '/magic-link' && magicLinkRedirect) {
            // Redirect as fast as possible to the external URL
            window.location.replace(magicLinkRedirect)
        } else if (redirectTo) {
            window.location.pathname = `/${redirectTo}/login`
        } else {
            showLoader()
            history.push(LOGIN_ROUTE)
        }
    },[ path, magicLinkRedirect, redirectTo, history ])

    const getMessage = () => {
        switch (path) {
            case APP_MAINTENANCE:
                setMessage('maintenance')
                setTitle(translate('appMaintenance.title'))
                setVerbiage(translate('appMaintenance.content'))
                break
            case APP_INACTIVE:
                setMessage('inactive')
                setTitle(translate('appInactive.title'))
                setVerbiage(translate('appInactive.content'))
                break
            case FAILED_POLICY:
                setMessage('failedPolicy')
                setTitle(translate('failedPolicy.title'))
                setVerbiage(translate('failedPolicy.content'))
                break
            case LOGOUT_SUCCESS:
                setMessage('logout')
                setTitle(translate('logoutSuccess.title'))
                setVerbiage(translate('logoutSuccess.content'))
                break
            case PASSWORD_CHANGED:
                setMessage('passwordChanged')
                setTitle(translate('passwordChanged.title'))
                setVerbiage(translate('passwordChanged.verbiage'))
                break
            case SECURITY_WARNING:
                setMessage('securityWarning')
                setTitle(translate('securityWarning.title'))
                setVerbiage(translate('securityWarning.content'))
                setAddButton(true)
                break
            case '/magic-link':
                setTitle(translate('magicLink.title', 'Magic Link Login'))
                setVerbiage(translate('magicLink.verbiage', 'Click the button below to continue.'))
                break    
            default:
                return 'Unknown Message'
        }
    }

    return (<>
        {path !== LOGOUT_SUCCESS && path !== PASSWORD_CHANGED ? <AppBar /> : <AppBarNew />}
        <Grid container className={path !== LOGOUT_SUCCESS && path !== PASSWORD_CHANGED ? classes.gridContainerCenter : classes.gridContainerCenterNew}>
            <Grid className={classes.noAccessRoot} md={5} sm={8} xs={12}>
                {path !== LOGOUT_SUCCESS && path !== PASSWORD_CHANGED && <RegistrationContainer {...{ title, verbiage }}>
                    {addButton
                        ? <Button
                            className={classes.button}
                            color='primary'
                            onClick={handleOnclick}>
                            {translate('loginButton')}
                        </Button>
                        : <></>
                    }
                </RegistrationContainer>}
                { (path === LOGOUT_SUCCESS || path === PASSWORD_CHANGED) && <MessageContainer {...{ message, title, verbiage }}>
                    {addButton
                        ? <Button
                            className={classes.buttonLogin}
                            onClick={handleOnclick}>
                            {translate('loginButton')}
                        </Button>
                        : <></>
                    }
                </MessageContainer>}
            </Grid>
        </Grid>
        {path !== LOGOUT_SUCCESS && path !== PASSWORD_CHANGED ? <Grid container className={classes.gridContainerCenter}>
            <Grid md={5} sm={8} xs={12}>
                <Footer />
            </Grid>
        </Grid> : <Grid container className={classes.gridContainerCenter}>
            <FooterNew />
        </Grid>}
    </>)
}

Component.displayName = 'StandardMessage'

Component.propTypes = {
    classes: PropTypes.shape({
        loader: PropTypes.object
    }),
}

export default withStyles(Component, styles)
